import styled from 'styled-components';
import {
  Text3,
  Text3M,
  Text4M,
} from '../genericComponents/texts';
import { BlankSpace } from '../genericComponents/layouts';
import Scoring from '../models/scoring.model';
import ScoringPointAndSummaryVehiclesComponent from '../components/ScoringPointAndSummaryVehiclesComponent';
import { priceFormat, roundPrice } from '../priceFormat';
import Warning from '../assets/img/Warning.svg';
import CheckCircle from '../assets/img/CheckCircle.svg';
import ArrowDown2 from '../assets/img/ArrowDown2.svg';
import warning from '../assets/img/warning.png';

interface Props {
  scoring: Scoring;
  autofactPrice: number;
}

interface DetailItem {
  showDescriptionToCustomer?: boolean;
  description?: string;
  ruleName?: string;
  scoreApplied?: number;
  wasCalculatedSuccessfully?: boolean;
  textColor?: string;
}

export default function ScoringSection(props:Props) {
  const { scoring, autofactPrice } = props;

  const ScoringData = { scoring };
  const finalScore = scoring.finalScore ? scoring.finalScore : 0;

  let amountItemModifyPrice = 0;
  let amountItemPreventSale = 0;
  let pointStatus = '';

  if (finalScore <= 50) pointStatus = 'bajo';
  if (finalScore >= 51 && finalScore <= 70) pointStatus = 'regular';
  if (finalScore >= 71 && finalScore <= 95) pointStatus = 'bueno';
  if (finalScore >= 96 && finalScore <= 100) pointStatus = 'excelente';

  let discountAuction = 0;
  const discountInfractions = scoring.infractions.value ? scoring.infractions.value : 0;

  const infractionsOverPercentage = (discountInfractions / autofactPrice) > 0.7;

  let ruleFine: DetailItem = {};
  let ruleAuction: DetailItem = {};
  let ruleRegistration: DetailItem = {};
  let ruleDomainLimitations: DetailItem = {};
  let ruleDomainLimitationsCritical: DetailItem = {};
  let ruleDomainLimitationsNoCritical: DetailItem = {};
  let ruleStolen: DetailItem = {};

  const messages = {
    fines: {
      ok: 'No posee multas',
      alert: 'Deuda multas',
      alertWithInfractions: 'Con multas, supera el 70% del precio',
    },
    auction: {
      ok: 'Sin pérdida total',
      alert: '*Con remate, sugerimos restar al menos 20%',
    },
    registration: {
      ok: 'Sin problemas de inscripción',
      alert: 'Con problemas de inscripción',
    },
    domain: {
      ok: 'Sin limitaciones al dominio',
      alert: 'Con limitaciones al dominio',
    },
    domainCritical: {
      ok: 'Sin limitaciones al dominio críticas',
      alert: 'Con limitaciones al dominio críticas',
    },
    domainNoCritical: {
      ok: 'Sin limitaciones al dominio no críticas',
      alert: 'Con limitaciones al dominio no críticas',
    },
    stolen: {
      ok: 'Sin encargo por robo',
      alert: 'Con encargo por robo',
    },
  };

  if (scoring.detail) {
    scoring.detail.forEach((item) => {
      const color = item.scoreApplied ? 'red' : 'green';

      if (item.ruleName === 'Infracciones anotadas' && item.wasCalculatedSuccessfully) {
        ruleFine = item;
        ruleFine.textColor = color;
        amountItemModifyPrice = item.scoreApplied ? amountItemModifyPrice += 1 : amountItemModifyPrice;
      }
      if (item.ruleName === 'Remate por perdida total' && item.wasCalculatedSuccessfully) {
        ruleAuction = item;
        ruleAuction.textColor = color;
        amountItemModifyPrice = item.scoreApplied ? amountItemModifyPrice += 1 : amountItemModifyPrice;
        discountAuction = item.scoreApplied ? (autofactPrice * 20) / 100 : 0;
      }

      if (item.ruleName === 'Inscripción cancelada' && item.wasCalculatedSuccessfully) {
        ruleRegistration = item;
        ruleRegistration.textColor = color;
        amountItemPreventSale = item.scoreApplied ? amountItemPreventSale += 1 : amountItemPreventSale;
        messages.registration.alert = item.description;
      }
      if (item.ruleName === 'Limitaciones al dominio' && item.wasCalculatedSuccessfully) {
        ruleDomainLimitations = item;
        ruleDomainLimitations.textColor = color;
        amountItemPreventSale = item.scoreApplied ? amountItemPreventSale += 1 : amountItemPreventSale;
      }
      if (item.ruleName === 'Limitaciones al dominio críticas' && item.wasCalculatedSuccessfully) {
        ruleDomainLimitationsCritical = item;
        ruleDomainLimitations.textColor = color;
        amountItemPreventSale = item.scoreApplied ? amountItemPreventSale += 1 : amountItemPreventSale;
      }
      if (item.ruleName === 'Limitaciones al dominio no críticas' && item.wasCalculatedSuccessfully) {
        ruleDomainLimitationsNoCritical = item;
        ruleDomainLimitations.textColor = color;
        amountItemPreventSale = item.scoreApplied ? amountItemPreventSale += 1 : amountItemPreventSale;
      }
      if (item.ruleName === 'Encargo por robo' && item.wasCalculatedSuccessfully) {
        ruleStolen = item;
        ruleStolen.textColor = color;
        amountItemPreventSale = item.scoreApplied ? amountItemPreventSale += 1 : amountItemPreventSale;
      }
    });
  }

  const recommendedPrice = autofactPrice - discountAuction - discountInfractions;
  const textPriceSaleRecommend = amountItemPreventSale || infractionsOverPercentage ? 'No recomendamos la compra o venta' : `$ ${priceFormat(roundPrice(recommendedPrice, 5))}`;
  const showAlert = !!(finalScore < 100 && amountItemPreventSale === 0 && amountItemModifyPrice === 0);

  let msjInfractions = '';
  if (ruleFine.scoreApplied) msjInfractions = `${messages.fines.alert} $ ${priceFormat(discountInfractions)}`;
  if (infractionsOverPercentage) msjInfractions = messages.fines.alertWithInfractions;

  return (
    <>
      <Container>
        <SubCont1>
          <>
            <PaddingContainer>
              <Text3>
                Esta sección permite saber si existen antecedentes legales que pueden modificar el precio de compra-venta sugerido. Información exclusiva por la compra de
                <Text3M> Pack Informe Full + Informe Precio y Tasación.</Text3M>
              </Text3>

              <BlankSpace height="15px" />

              <CardTipsSunCont1>
                <CardTipsSunCont2>
                  <Text3>
                    <Text3M>
                      <span style={{ color: amountItemModifyPrice ? 'red' : 'green' }}>
                        {amountItemModifyPrice}
                        {' '}
                        ítem
                        {' '}
                      </span>
                    </Text3M>
                    que puede modificar el precio recomendado
                  </Text3>

                  <BlankSpace height="15px" />

                  <Text3>
                    <Text3M>
                      <span style={{ color: amountItemPreventSale ? 'red' : 'green' }}>
                        {amountItemPreventSale}
                        {' '}
                        ítem
                        {' '}
                      </span>
                    </Text3M>
                    que impiden la venta del vehículo
                  </Text3>
                </CardTipsSunCont2>
              </CardTipsSunCont1>
            </PaddingContainer>

            <LineDSK />

            <PaddingContainer>

              <CardTitle>
                <ItemTitle text="Precio de venta recomendado" text2={`$ ${priceFormat(roundPrice(autofactPrice, 5))}`} />
              </CardTitle>

              <Text3M>Ajustes de precio específicos:</Text3M>
              <BlankSpace height="5px" />

              <SubCont4>
                <ItemSettings
                  key="1"
                  text="Multas anotadas"
                  text2={ruleFine.scoreApplied
                    ? msjInfractions
                    : messages.fines.ok}
                  icon={ruleFine.scoreApplied ? ArrowDown2 : CheckCircle}
                  textColor={ruleFine.textColor ? ruleFine.textColor : ''}
                />

                <ItemSettings
                  key="2"
                  text="Remates por pérdida todal"
                  text2={ruleAuction.scoreApplied ? messages.auction.alert : messages.auction.ok}
                  icon={ruleAuction.scoreApplied ? ArrowDown2 : CheckCircle}
                  textColor={ruleAuction.textColor ? ruleAuction.textColor : ''}
                />
              </SubCont4>

              <BlankSpace height="15px" />

              <Text4M>Items que pueden impedir la venta:</Text4M>
              <BlankSpace height="5px" />

              <SubCont4>
                <ItemSettings
                  key="1"
                  text="Inscripción"
                  text2={ruleRegistration.scoreApplied ? messages.registration.alert : messages.registration.ok}
                  icon={ruleRegistration.scoreApplied ? Warning : CheckCircle}
                  textColor={ruleRegistration.textColor ? ruleRegistration.textColor : ''}
                />

                <ItemSettings
                  key="2"
                  text="Limitaciones al dominio"
                  text2={ruleDomainLimitations.scoreApplied || ruleDomainLimitationsCritical.scoreApplied || ruleDomainLimitationsNoCritical.scoreApplied ? messages.domain.alert : messages.domain.ok}
                  icon={ruleDomainLimitations.scoreApplied || ruleDomainLimitationsCritical.scoreApplied || ruleDomainLimitationsNoCritical.scoreApplied ? Warning : CheckCircle}
                  textColor={ruleDomainLimitations.scoreApplied || ruleDomainLimitationsCritical.scoreApplied || ruleDomainLimitationsNoCritical.scoreApplied ? 'red' : 'green'}
                />

                <ItemSettings
                  key="3"
                  text="Encargo por robo"
                  text2={ruleStolen.scoreApplied ? messages.stolen.alert : messages.stolen.ok}
                  icon={ruleStolen.scoreApplied ? Warning : CheckCircle}
                  textColor={ruleStolen.textColor ? ruleStolen.textColor : ''}
                />
              </SubCont4>

              <RecommendedPrice>
                <ItemTitle text="Precio de venta sugerido:" text2={textPriceSaleRecommend} />
              </RecommendedPrice>

            </PaddingContainer>

          </>
        </SubCont1>
        <SubCont2>
          <ScoringPointAndSummaryVehiclesComponent scoringData={ScoringData} />
          <BlankSpace height="15px" />
        </SubCont2>
      </Container>
      {
        ruleAuction.scoreApplied
          ? (
            <PaddingContainer>
              <Text3>
                <Text3M>*Remate por pérdida total: </Text3M>
                Sugerimos restar al menos un 20% al precio de mercado según datos de publicaciones disponibles. Dependiendo del modelo y condiciones del vehículo el porcentaje a descontar puede llegar hasta un 45%.
              </Text3>
            </PaddingContainer>
          )
          : ''
      }
      {
        showAlert
          ? (
            <PaddingContainer>
              <WarningScoring pointStatus={pointStatus} />
            </PaddingContainer>
          )
          : ''
      }
    </>
  );
}
function ItemTitle({ text, text2 }: { text: string, text2: string }) {
  return (
    <ContainerItemSettings>
      <Text4M>{text}</Text4M>
      <Text4M>{text2}</Text4M>
    </ContainerItemSettings>
  );
}
function ItemSettings({
  text,
  text2,
  icon,
  textColor,
}: { text: string, text2: string, icon: string, textColor: string; }) {
  return (
    <div>
      <Table>
        <tbody>
          <tr>
            <Tabletd>
              <Text3>{text}</Text3>
            </Tabletd>
            <TabletdRight style={{ width: '50%' }}>
              <strong style={{ color: textColor }}>{text2}</strong>
            </TabletdRight>
            <TabletdRight style={{ width: '20px' }}>
              <img src={icon} width={15} height={15} alt="" />
            </TabletdRight>
          </tr>
        </tbody>
      </Table>
    </div>
  );
}

function WarningScoring({ pointStatus }:{pointStatus: string}) {
  return (
    <CadrWarningContainer>
      <img src={warning} width={25} height={25} alt="" />
      <BlankSpace width="15px" />
      <div>
        <Text3>
          <Text3M>Importante: </Text3M>
          Según informe historial este vehículo tiene un puntaje
          <Text3M>
            {' '}
            {pointStatus}
          </Text3M>
          , sin embargo esto no afecta el precio de venta según los items analizados.
        </Text3>
        <BlankSpace height="0px" />
        <Text3>
          <Text3M>Recomendamos consultar el informe historial</Text3M>
          {' '}
          para más información.
        </Text3>
      </div>
    </CadrWarningContainer>
  );
}

const CadrWarningContainer = styled.div`
  max-width: 100%;
  background-color: #fdf0d7;
  border: 2px solid #FFC048;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding: 10px 10px;
  margin: 0px 0px 0px 0px;
`;

const ContainerItemSettings = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content:space-between;
  align-items: center;
  margin: 10px 0;
`;

const Container = styled.div`
  width: 100%;
  padding: 10px 0;
  display: flex;
  flex-direction: row;
  @media (max-width: 700px){
    flex-direction: column;
  }
`;

const SubCont1 = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 10px 0px -10px;
  justify-items: flex-start;
  width: 65%;
  @media (max-width: 700px){
    width: unset;
    flex:1;
  }
`;

const SubCont2 = styled.div`
  display: flex;
  flex-direction: column;
  width: 35%;
  padding: 0px 10px;
  border: none;
  @media (max-width: 700px){
    border-top: 1px solid #EBF1F5;
    padding-top: 20px;
    width: unset;
    flex:1;
  }
`;
const CardTipsSunCont1 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;
const CardTipsSunCont2 = styled.div`
  flex: 1;
  display: flex;
  padding: 0 0 0 15px;
  flex-direction: column;
`;
const LineDSK = styled.div`
  width: 100%;
  height: 1px;
  background-color:#EBF1F5;
  @media (max-width: 700px){
    display: none;
  }
`;
const PaddingContainer = styled.div`
  padding: 0px 10px 10px 10px;
`;

const RecommendedPrice = styled.div`
  padding: 5px 5px;
  margin-top: 5px;
  border-radius: 5px;
  background: #EBF1F5;
`;
const SubCont4 = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 700px){
    flex: 1;
  }
`;
export const CardTitle = styled.label`
  font-size: 16px;
  color: #155892;
  font-family: 'Roboto medium';

  @media (max-width: 700px){
    font-size: 14px;
  }
`;
const Table = styled.table`
  margin: 8px 0;
  border: none;
  width: 100%;
  @media (max-width: 700px){
    width: 100%;
  }
`;

const Tabletd = styled.td`
  font-size: 12px;
  color: #3D5176;
  font-family: 'Roboto medium';
  padding: 0px 0;
  @media (max-width: 700px){
    width: 10%;
    padding: 0px 0;
  }
`;
const TabletdRight = styled.td`
  font-size: 12px;
  color: #3D5176;
  font-family: 'Roboto medium';
  text-align: right;
  padding: 0px 0;
  @media (max-width: 700px){
    width: 10%;
    padding: 0px 0;
  }
`;
